/* ============================================================
   Lack Depot — Unified Variant Picker enhancements

   1. Color dot injection for non-RAL .option-name-farbe products
      (RAL ones handled by ral-color-picker.js).
   2. Size pill sort — XS, S, M, L, XL, XXL, XXXL.

   Idempotent. Re-runs after variant changes.
   Built 2026-06-18 by Claude via Cowork for Lack Depot.
   ============================================================ */
(function () {
  'use strict';

  var COLOR_HEX = {
    'schwarz': '#1a1a1a',
    'weiß': '#f8f8f8',
    'weiss': '#f8f8f8',
    'rot': '#cc1f1f',
    'blau': '#1f4ccc',
    'grün': '#2ea15c',
    'gruen': '#2ea15c',
    'gelb': '#f5d11f',
    'orange': '#f08c1f',
    'violett': '#7a3aa6',
    'lila': '#a259c4',
    'grau': '#9a9a9a',
    'hellgrau': '#cccccc',
    'dunkelgrau': '#5e5e5e',
    'braun': '#7a4a2b',
    'beige': '#d9c4a3',
    'transparent': null,
    'farblos': null,
    'klar': null,
    'klarlack': null
  };
  var GRADIENTS = {
    'silber': 'linear-gradient(135deg, #d8d8d8 0%, #f5f5f5 35%, #b0b0b0 55%, #ececec 100%)',
    'gold': 'linear-gradient(135deg, #d4af6e 0%, #f5d99a 35%, #b8860b 55%, #e6c47a 100%)',
    'kupfer': 'linear-gradient(135deg, #b87333 0%, #e4a76b 35%, #8b4a1a 55%, #d68d50 100%)',
    'bronze': 'linear-gradient(135deg, #8b6b2a 0%, #b58a3d 50%, #6e4f1d 100%)',
    'titan':  'linear-gradient(135deg, #6e6e6e 0%, #b0b0b0 50%, #4a4a4a 100%)',
    'platin': 'linear-gradient(135deg, #c0c0c0 0%, #ececec 50%, #9d9d9d 100%)'
  };
  var CHECKER_BG = 'repeating-conic-gradient(#ddd 0% 25%, #fff 0% 50%) 50% / 8px 8px';

  function bestSwatch(valueStr) {
    if (!valueStr) return null;
    var v = valueStr.toLowerCase().trim();
    if (COLOR_HEX.hasOwnProperty(v)) {
      var hex = COLOR_HEX[v];
      return hex == null ? { background: CHECKER_BG } : { background: hex };
    }
    if (GRADIENTS.hasOwnProperty(v)) return { background: GRADIENTS[v] };
    var keys = Object.keys(COLOR_HEX).concat(Object.keys(GRADIENTS));
    keys.sort(function (a, b) { return b.length - a.length; });
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (new RegExp('\\b' + k + '\\b', 'i').test(v)) {
        if (COLOR_HEX.hasOwnProperty(k)) {
          var h = COLOR_HEX[k];
          return h == null ? { background: CHECKER_BG } : { background: h };
        }
        return { background: GRADIENTS[k] };
      }
    }
    return null;
  }

  function decorateColorLabel(label, value) {
    if (!label || label.querySelector('.ld-color-dot')) return;
    var swatch = bestSwatch(value);
    if (!swatch) return;
    var dot = document.createElement('span');
    dot.className = 'ld-color-dot';
    dot.style.background = swatch.background;
    dot.setAttribute('aria-hidden', 'true');
    label.insertBefore(dot, label.firstChild);
  }

  var SIZE_RANK = {
    'xs': 1, 's': 2, 'm': 3, 'l': 4, 'xl': 5, 'xxl': 6, 'xxxl': 7,
    'small': 2, 'medium': 3, 'large': 4
  };
  function sizeRank(v) {
    var k = (v || '').toLowerCase().trim();
    if (SIZE_RANK.hasOwnProperty(k)) return SIZE_RANK[k];
    var n = parseFloat(k);
    return isNaN(n) ? 999 : n;
  }
  function sortSizePills(fieldset) {
    var inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
    if (inputs.length < 2) return;
    var pairs = inputs.map(function (inp) {
      var lbl = fieldset.querySelector('label[for="' + inp.id + '"]');
      return { input: inp, label: lbl, rank: sizeRank(inp.value) };
    });
    pairs.sort(function (a, b) { return a.rank - b.rank; });
    pairs.forEach(function (p) {
      if (p.input) fieldset.appendChild(p.input);
      if (p.label) fieldset.appendChild(p.label);
    });
  }

  function applyToFieldset(fieldset) {
    if (!fieldset || fieldset.dataset.ldVariantApplied === '1') return;
    fieldset.dataset.ldVariantApplied = '1';
    var classes = fieldset.className || '';
    if (/option-name-farbe\b/.test(classes)) {
      if (fieldset.querySelector('.ral-picker__grid')) return;
      var inputs = fieldset.querySelectorAll('input[type="radio"]');
      inputs.forEach(function (inp) {
        var lbl = fieldset.querySelector('label[for="' + inp.id + '"]');
        if (lbl) decorateColorLabel(lbl, inp.value);
      });
    } else if (/option-name-(größe|grosse)\b/i.test(classes)) {
      sortSizePills(fieldset);
    }
  }
  function applyAll() {
    document.querySelectorAll('fieldset.product-form__input[class*="option-name-"]').forEach(applyToFieldset);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll);
  } else {
    applyAll();
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('input[type="radio"][name^="options"]')) {
      setTimeout(function () {
        document.querySelectorAll('fieldset.product-form__input[data-ld-variant-applied="1"]').forEach(function (fs) {
          delete fs.dataset.ldVariantApplied;
        });
        applyAll();
      }, 100);
    }
  });
})();
